module.exports = __webpack_public_path__ + "img/smoothie.45045bf1.gif";